<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="600"
  >
    <v-card>
      <v-card-text>
        <v-form
          ref="formEntidadTecnicaPorExcel"
          lazy-validation
          @submit.prevent="save()"
        >
          <v-card-title class="pa-2">
            Crear entidad técnica
            <v-spacer />
          </v-card-title>

          <div>
            <v-file-input
              id="file"
              placeholder="Sube tu archivo"
              label="File input"
              :loading="loadingJSon"
              :rules="[v => !!v || 'El teléfono personal es obligatorio']"
              :error-messages="fileExcel"
              @change="previewFiles"
            />
            <v-divider />
          </div>

          <template>
            <v-progress-linear
              v-if="isLoadinguploadFile"
              v-model="progressUploadFile"
              value="15"
              height="25"
            >
              <span
                color="white"
              >
                {{ progressUploadFile.toFixed(0) }} %
              </span>
            </v-progress-linear>
          </template>

          <v-card-actions class="pa-2">
            <v-btn
              outlined
              @click="close"
            >
              Cancelar
            </v-btn>
            <a 
              class="px-2 py-1" 
              outlined
              href="https://firebasestorage.googleapis.com/v0/b/proyectouno-719dd.appspot.com/o/Descargar%20Formato%20Entidades%20Tecnicas.xlsx?alt=media&token=63e90a31-d2ae-4045-9a99-be273459e6cf"
            >
              Descargar Formato
            </a>
            <v-spacer />
            <v-btn
              color="primary"
              type="submit"
              :loading="loading"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  // import firebase from 'firebase'
  // const db = firebase.firestore()
  import XLSX from 'xlsx'

  export default {
    data () {
      return {
        dialog: false,
        loading: false,
        loadingJSon: false,
        fileExcel: '',
        progressUploadFile: 0,
        isLoadinguploadFile: false,
        existeEntidadTecnica: [],
        userUid: '',
        data_excel: []
      }
    },
    methods: {
      open () {
        this.dialog = true
      },
      close () {
        this.dialog = false
        this.loading = false
        this.$refs.formEntidadTecnicaPorExcel.reset()
      },
      async save () {
        if (this.$refs.formEntidadTecnicaPorExcel.validate()) {
          this.loading = true
          await this.uploadExcel()
        }
      },
      async uploadExcel () {
        var myHeaders = new Headers()
        myHeaders.append('Content-Type', 'application/json')

        var raw = JSON.stringify({
          data: [
            ...this.data_excel
          ]
        })

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow'
        }

        const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/entidad/excel', requestOptions)
        const data = await response.json()
        if (data.success) {}

        this.$emit('onUploadExcel')
        this.close()
        this.isLoadinguploadFile = false
      },
      previewFiles (e) {
        this.loadingJSon = true

        const file = document.getElementById('file').files[0]
        if (file) {
            const fileReader = new FileReader()
            fileReader.readAsBinaryString(file)
            fileReader.onload = (event) => {
            const data = event.target.result
            const workbook = XLSX.read(data, { type: 'binary' })
            workbook.SheetNames.forEach(async sheet => {
                const rowObject = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet])
                this.data_excel = rowObject
                // await this.sendData()
                })
            }
        }
        this.loadingJSon = false
      },
    },

  }
</script>

<style>

</style>
